module.exports = function isNumber(x) {
  return typeof x === 'number' && isFinite(x) && !isNaN(x);
};


//////////////////
// WEBPACK FOOTER
// ./~/tcomb/lib/isNumber.js
// module id = 494
// module chunks = 0